import { render, staticRenderFns } from "./labelManage.vue?vue&type=template&id=0f3fc7a2&scoped=true"
import script from "./labelManage.vue?vue&type=script&lang=js"
export * from "./labelManage.vue?vue&type=script&lang=js"
import style0 from "./labelManage.vue?vue&type=style&index=0&id=0f3fc7a2&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f3fc7a2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f3fc7a2')) {
      api.createRecord('0f3fc7a2', component.options)
    } else {
      api.reload('0f3fc7a2', component.options)
    }
    module.hot.accept("./labelManage.vue?vue&type=template&id=0f3fc7a2&scoped=true", function () {
      api.rerender('0f3fc7a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/matrix/labelManage.vue"
export default component.exports